export default "__VITE_ASSET__L9hT9rwa__"